<template>
  <div>
    <el-tabs v-model="activeName" tab-position="left" class="XJTab">
      <el-tab-pane v-for="(item, index) in XJList" :key="index" :label="item.name" :name="item.name">
        <el-row>
          <div class="contentTitle"
               style="color: #ee7a18; font-size: 36px; padding: 20px 100px 0px 100px">
            {{that.$root.language == 1?item.textName:item.textName_en1}}
          </div>
          <div class="contentTitle"
               v-if="that.$root.language != 1"
               style="color: #ee7a18; font-size: 16px; padding: 0px 100px 20px 100px">
               {{item.textName_en2}}
          </div>
          <div class="content" style="padding: 20px 100px">
            <div class="top" style="padding-bottom: 20px; font-size: 24px">
              {{that.$root.language == 1?'1、产品概述':'1. GENERAL DESCRIPTION'}}
            </div>
            <div v-show="item.description1" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description1:item.description1_en}}
            </div>
            <div v-show="item.description2" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description2:item.description2_en}}
            </div>
            <div v-show="item.description3" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description3:item.description3_en}}
            </div>
            <div v-show="item.description4" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description4:item.description4_en}}
            </div>
            <div class="center" style="padding: 20px 0; font-size: 24px">
              {{that.$root.language == 1?'2、产品指标':'2、PRODUCT INDEX'}}
            </div>
            <img v-if="that.$root.language == 1" v-show="item.img1" :src="item.img1"
                 style="width: 100%" />
            <img v-if="that.$root.language != 1" v-show="item.img1" :src="item.img1_en"
                 style="width: 100%" />
            <div class="bottom" style="padding: 20px 0; font-size: 24px">
              {{that.$root.language == 1?'3、应用性能比较':'3、TECHNICAL DATA'}}
            </div>
            <div v-show="item.compare1" class="compare" style="padding: 10px 0;text-indent: 2em">{{that.$root.language == 1?item.compare1:item.compare1_en}}</div>
            <div v-show="item.compare2" class="compare" style="padding: 10px 0;text-indent: 2em">{{that.$root.language == 1?item.compare2:item.compare2_en}}</div>
            <div v-show="item.compare3" class="compare" style="padding: 10px 0;text-indent: 2em">{{that.$root.language == 1?item.compare3:item.compare3_en}}</div>
            <div v-show="item.compare4" class="compare" style="padding: 10px 0;text-indent: 2em">{{that.$root.language == 1?item.compare4:item.compare4_en}}</div>
            <div v-show="item.compare5" class="compare" style="padding: 10px 0;text-indent: 2em">{{that.$root.language == 1?item.compare5:item.compare5_en}}</div>
            <div v-show="item.compare6" class="compare" style="padding: 10px 0;text-indent: 2em">{{that.$root.language == 1?item.compare6:item.compare6_en}}</div>
            <img v-if="that.$root.language == 1" v-show="item.img2" :src="item.img2" style="width: 100%" />
            <img v-if="that.$root.language != 1" v-show="item.img2" :src="item.img2_en" style="width: 100%" />
            <div class="remark">
              <div v-show="item.remark1" class="remarkFir" style="padding: 10px 0"> {{that.$root.language == 1?item.remark1:item.remark1_en}}</div>
              <div v-show="item.remark2" class="remarkSec" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark2:item.remark2_en}}</div>
              <div v-show="item.remark3" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark3:item.remark3_en}}</div>
              <div v-show="item.remark4" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark4:item.remark4_en}}</div>
              <div v-show="item.remark5" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark5:item.remark5_en}}</div>
              <div v-show="item.remark6" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark6:item.remark6_en}}</div>
              <div v-show="item.remark7" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark7:item.remark7_en}}</div>
            </div>
            <div class="fourth" style="padding: 20px 0; font-size: 24px">
              {{that.$root.language == 1?'4、产品供应':'4、PRODUCT SUPPLY'}}
            </div>
            <div v-show="item.pack1" style="padding: 10px 0">{{that.$root.language == 1?item.pack1:item.pack1_en}}</div>
            <div v-show="item.pack2" style="padding: 10px 0">{{that.$root.language == 1?item.pack2:item.pack2_en}}</div>
            <div v-show="item.pack3" style="padding: 10px 0">{{that.$root.language == 1?item.pack3:item.pack3_en}}</div>
            <div v-show="item.pack4" style="padding: 10px 0">{{that.$root.language == 1?item.pack4:item.pack4_en}}</div>
          </div>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
        that:this,
        activeName: 'N330负极专用',
        XJList: [
        {
          name: "N330负极专用",
          textName: '安仑负极专用N330炭黑',
          textName_en1: 'N330 CARBON BLACK',
          textName_en2: '（CUSTOMIZED FOR GRAPHITIZATION OF ANODE MATERIALS OF LITHIUM ION BATTERY）',
          description1: '负极专用N330是安仑化工推出的一款用于制造锂离子电池负极原料的基础炭材料，主要用于人造石墨生产过程中的保温和绝缘材料。',
          description1_en: 'A special N300 series product launched by Anlun Chemical, which is widely used as thermal and \n' +
              'electric insulation material of the graphitization furnace during the production of artificial graphite.',
          compare1: '相对于普通N330，负极专用N330主要具有如下优点：',
          compare1_en: 'The special N330 carbon black has the following advantages over the regular N330:',
          compare2: '挥发分低，有效避免石墨化过程中的喷炉风险；',
          compare2_en: 'Low volatilization largely reduces the risk of furnace explosion during graphitization.',
          compare3: '体积电阻率高，延长使用寿命，减少维修成本；',
          compare3_en: 'Low ash and sulfur content does not affect the purity of artificial graphite.',
          compare4: '灰分、硫含量低。',
          compare4_en: 'High volume resistivity prolongs the service life of carbon black with low maintenance.',
          remark1:'',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet palletization.',
          pack2: '包装： 500kg FIBC; 1,000kg FIBC',
          pack2_en: 'Packaging: 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/nengyuan/N330fuji-1.jpg"),
          img1_en: require("../../assets/img/nengyuan/N330fuji-1-EN.jpg"),
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
  width: 150px;
}
::v-deep .el-tabs__item.is-active {
  background-color: rgba($color: #000000, $alpha: 0.1);
}
::v-deep .el-tabs__nav{
  background-color: #ffffff !important;
  color: #000000 !important;
}
::v-deep .el-tabs__item.is-active {
  color: #ee7a18 !important;
}
::v-deep .el-tabs__item:hover {
    color: #ee7a18 !important;
    cursor: pointer !important;
}
::v-deep #tab-N330负极专用 {
  text-align: center;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
}
</style>